import { JSXElementConstructor, PropsWithChildren, ReactElement } from 'react'

import { Box, Card, Tag, TagColor, Text } from '@factorialco/deprecated-design-system'

// Comes from Card.Eyebrow
type Element = ReactElement<PropsWithChildren, JSXElementConstructor<unknown>>

interface AccountListCardProps {
  logo: Element
  statusType: TagColor
  status: string
  title: string
  description: string
  to?: string | null
  linkText?: string
  footerText?: string
  onClick?: () => void
}

export const AccountsPageCard = ({
  logo,
  statusType,
  status,
  title,
  description,
  to,
  linkText: toText,
  footerText,
  onClick,
}: AccountListCardProps) => {
  return (
    <Box>
      <Card height="s200" to={to ?? undefined} onClick={onClick}>
        <Card.Eyebrow>
          {logo}
          <Tag ellipsis={false} type={statusType} size="normal" leftItem="circle" showCircle>
            {status}
          </Tag>
        </Card.Eyebrow>
        <Card.Title size="small">{title}</Card.Title>
        <Card.Description>{description}</Card.Description>
        {!!toText && <Card.Link to={to ?? ''}>{toText}</Card.Link>}
        {!!footerText && (
          <Card.Footer>
            <Text size="400" color="grey1000" weight="semibold">
              {footerText}
            </Text>
          </Card.Footer>
        )}
      </Card>
    </Box>
  )
}
